import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import moment from 'moment-timezone';
import { get, isEmpty } from 'lodash';

import { Listings } from 'containers/AppContainer/typings';
import { JudgementADDDocumentType } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { translate } from 'containers/services/translate';
import { JUDGEMENT_ADD_DOCUMENT, LISTINGS } from 'containers/data-structure';
import { getValueByCode } from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
import judgementFormMessages from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/messages';
import messages from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/messages';

export interface JudgementAddComplementProps {
  intl: IntlShape;
  listings: Listings;
  judgementAddDocuments: JudgementADDDocumentType;
  isManager?: boolean;
}

const JudgementAddComplement: React.FC<JudgementAddComplementProps> = (
  props,
): JSX.Element => {
  const { judgementAddDocuments } = props;

  return (
    <>
      <section className="add-info">
        <article className="field">
          <div className="label">
            {translate(
              judgementFormMessages.judgementAddFormJudgementDate,
              props,
            )}
          </div>
          <div className="value">
            {moment(
              judgementAddDocuments[JUDGEMENT_ADD_DOCUMENT.JUDGEMENT_DATE],
            ).format('YYYY-MM-DD')}
          </div>
        </article>
        <article className="field">
          <div className="label">
            {translate(
              judgementFormMessages.judgementAddFormResponsibilityShare,
              props,
            )}

            {translate(
              judgementFormMessages.responsibiltySharePercentage,
              props,
            )}
          </div>
          <div className="value">
            {judgementAddDocuments[JUDGEMENT_ADD_DOCUMENT.RESPONSABILITY_SHARE]}
          </div>
        </article>
        {judgementAddDocuments[JUDGEMENT_ADD_DOCUMENT.CONVICTION_ID] &&
          !isEmpty(
            judgementAddDocuments[
              JUDGEMENT_ADD_DOCUMENT.CONVICTION_ID
            ].toString(),
          ) && (
            <article className="field">
              <div className="label">
                {translate(
                  judgementFormMessages.judgementAddFormConviction,
                  props,
                )}
              </div>
              <div className="value">
                {getValueByCode(
                  judgementAddDocuments[JUDGEMENT_ADD_DOCUMENT.CONVICTION_ID],
                  get(props.listings, LISTINGS.CONVICTION, []),
                )}
              </div>
            </article>
          )}
      </section>
      {props.isManager &&
        judgementAddDocuments[JUDGEMENT_ADD_DOCUMENT.RESPONSABILITY_SHARE] ===
          0 && (
          <section>
            <span style={{ color: 'red', fontSize: 12 }}>
              {translate(messages.responsibilityShareWarning, props)}
            </span>
          </section>
        )}
    </>
  );
};

export default injectIntl(JudgementAddComplement);
